import poliFoundationRequest from 'src/utils/poliFoundationRequest';

export interface UserPreferencesSummary {
	summary: number;
}

interface UpdateSummaryResponse {
	summary: number;
	summary_label: string;
	is_enabled: boolean;
}

export interface UserSettings {
	summary?: number;
	language?: string;
	[key: string]: any;
}

interface UpdateLanguageResponse {
	language: string;
}

export class UserPreferencesService {
	/**
	 * Busca as preferências resumidas do usuário
	 */
	static async getSummary(): Promise<UserPreferencesSummary> {
		try {
			const response = await poliFoundationRequest.get('/users/settings/summary');
			return response.data;
		} catch (error) {
			console.error('[UserPreferencesService] Failed to get summary:', error);
			throw error;
		}
	}

	static async updateSummary(
		forwardChatWithSummary: boolean,
	): Promise<UpdateSummaryResponse> {
		try {
			const summaryPayload = forwardChatWithSummary ? 1 : 0;
			const result = await poliFoundationRequest.put('/users/settings/summary', {
				summary: summaryPayload,
			});
			return result.data;
		} catch (error) {
			console.error(
				'[UserPreferencesService] Failed to update summary:',
				error,
			);
			throw error;
		}
	}

	/**
	 * Busca todas as configurações do usuário
	 */
	static async getUserSettings(): Promise<UserSettings> {
		try {
			const response = await poliFoundationRequest.get('/users/settings');
			return response.data;
		} catch (error) {
			console.error('[UserPreferencesService] Failed to get user settings:', error);
			throw error;
		}
	}

	/**
	 * Obtém o idioma salvo do usuário
	 */
	static async getLanguage(): Promise<UserSettings> {
		try {
			const response = await poliFoundationRequest.get('/users/settings/language');
			return response.data;
		} catch (error) {
			console.error('[UserPreferencesService] Failed to get language:', error);
			throw error;
		}
	}

	/**
	 * Atualiza o idioma do usuário
	 */
	static async updateLanguage(language: string): Promise<UpdateLanguageResponse> {
		try {
			// Converter pt-BR para pt, es-ES para es
			const normalizedLanguage = language.split('-')[0];
			
			const result = await poliFoundationRequest.post('/users/settings/language', {
				language: normalizedLanguage,
			});
			return result.data;
		} catch (error) {
			console.error('[UserPreferencesService] Failed to update language:', error);
			throw error;
		}
	}

	/**
	 * Atualiza configurações do usuário
	 */
	static async updateSettings(settings: UserSettings): Promise<UserSettings> {
		try {
			const result = await poliFoundationRequest.put('/users/settings', settings);
			return result.data;
		} catch (error) {
			console.error('[UserPreferencesService] Failed to update settings:', error);
			throw error;
		}
	}
}
